import {Component, EventEmitter, forwardRef, Input, OnInit, Output} from '@angular/core';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import moment, {Moment} from 'moment';
import {BaseControlValueAccessor} from '../base_control_value_accessor/base';
import {MatDatepickerInputEvent} from "@angular/material/datepicker";

export const MY_DATE_MONTH_YEAR_FORMAT = {
    parse: {
        dateInput: 'DD/MM/YYYY',
    },
    display: {
        dateInput: 'DD/MM/YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

@Component({
    selector: 'app-date-field',
    templateUrl: './date-field.component.html',
    styleUrls: ['../form-field.scss'],
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
        },
        {provide: MAT_DATE_FORMATS, useValue: MY_DATE_MONTH_YEAR_FORMAT},
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => DateFieldComponent),
        }
    ],
})

export class DateFieldComponent extends BaseControlValueAccessor implements OnInit {

    override _data: string | Date;

    override get data() {
        return this._data;
    }

    @Output() dateChange = new EventEmitter<MatDatepickerInputEvent<any>>();

    override set data(val: string | Date | null) {
        if (typeof val == 'string') {
            this._data = val;
            this.momentObj = moment(new Date(val));
        } else if (val instanceof Date) {
            this._data = val.toISOString();
            this.momentObj = moment(val.toISOString());
        } else if (val != null) {
            this._data = JSON.stringify(val).split('"').join('');
            this.momentObj = val;
        } else {
            this._data = val;
            this.momentObj = null;
        }
        this.errors = [];
        this.validate(this._data);
        this.onChange(this._data);
    }

    momentObj: Moment = null;

    @Input()
    minDate: Date | string = null;

    @Input()
    maxDate: Date | string = null;


    // @Output() dataChange = new EventEmitter();


    dateToString() {
        if (!this.momentObj)
            return '-'

        const saadaDate = this.momentObj.toDate();
        let date = saadaDate.getDate();
        let month = saadaDate.toLocaleString('default', {month: 'short'});
        let year = saadaDate.getFullYear()
        return `${date} ${month}, ${year}`;
    }

    constructor() {
        super();

    }

    ngOnInit(): void {
    }

    setDate(date) {
        this.data = date;
    }

    override validate(val) {
    }

    dateChanged(date) {
        this.dateChange.emit(date);
    }

}
